import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "codes-pane full-width full-height flex column min-height" }
const _hoisted_2 = { class: "codes-search-bar-container" }
const _hoisted_3 = { class: "code-tables-container full-width min-height" }
const _hoisted_4 = { class: "code-tables-scroller full-height" }

import CodesSearchBar from 'components/codes/CodesSearchBar.vue';
import ProceduresPane from 'components/codes/ProceduresPane.vue';
import DiagnosisPane from 'components/codes/DiagnosisPane.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'CodesPane',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(CodesSearchBar)
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createVNode(DiagnosisPane),
        _createVNode(ProceduresPane)
      ])
    ])
  ]))
}
}

})